<!-- <mat-toolbar color="primary" class="mat-elevation-z2">
  <button
    type="button"
    aria-label="Toggle sidenav"
    mat-icon-button
    (click)="drawer.toggle()"
    *ngIf="isHandset$ | async"
  >
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <span class="left">
    </span>
  <span class="middle"> </span>
  <span class="right" style=" align-items: stretch;" >
                <button
                  mat-button
                  routerLink="/tarife"
                  [disabled]="!login_activated"
                  style="margin-right: 1em"
                >
        Produkt Listen
    </button>
      <button
        mat-button
        [disabled]="!login_activated"
        routerLink="/"
        style="margin-right: 1em"
      >
        Hilfe
    </button>
      <button
        mat-button
        [disabled]="!login_activated"
        style="margin-right: 1em"
      >
        <a href="mailto:contact@bimswarm.de">Kontakt</a>
    </button>

    </span>
</mat-toolbar> -->

<!-- first section -->
<div class="firstHeader"><span class="info-text"></span>
</div>

<!-- second section with -->
<div class="secondaryHeader mat-elevation-z1">
  <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="clickedMenu()"
    *ngIf="(isHandset$ | async) === true">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>
  <span class="left" [style]="'position: relative'">
    <a *ngIf="
                !router.url.includes('/marktplatz')
            " routerLink="/" class="logoSecondary" (click)="routeToMarketplace()"
      aria-label="BIMSWARM Startseite"></a>
    <a *ngIf="router.url.includes('/marktplatz')" routerLink="/" activatedRoute="" (click)="this.clickedLogo()"
      class="logoSecondary" aria-label="BIMSWARM Startseite"></a>
  </span>
  <!--   <span class="middle"> </span> -->
  <span class="right right-btn-container">
     <!-- <button *ngIf="router.url.includes('/marktplatz')" routerLink="/tarife" [disabled]="!login_activated"
     class="btn-package btn-border-line" mat-button>
      Produkt listen
    </button> -->
    <app-profile [loggedIn]="loggedIn" class="right-action-btn"></app-profile>
  </span>
</div>

<!-- third section with tabs for setting pages (f.ex. Einstllungen & Produkte) or just white space -->
<div class="headerNoTabs" *ngIf="
  (headerText$ | async) === 'Impressum' ||
  (headerText$ | async) === 'Datenschutzerklärung' ||
  (headerText$ | async) === 'AGB' ||
  router.url.includes('/tarife') ||
  router.url.includes('/profil')  ||
  (router.url.includes('/organisations/') && router.url.includes('/firstProduct')) ||
  (router.url.includes('/organisations/') && router.url.includes('/aboPayment')) ||
  router.url.includes('/sitemap')
"></div>
<mat-tab-group mat-stretch-tabs="false" style="    position: sticky;" mat-align-tabs="center" color="primary"
  [(selectedIndex)]="headerService.activeTabIndex" (selectedTabChange)="headerService.changedTab($event)" *ngIf="router.url.includes('/organisations') &&
           !router.url.includes('/firstProduct') &&
           !router.url.includes('/aboPayment'); else lastHeader">
  <mat-tab *ngFor="let menuTab of headerService.getMenuTabs()">
    <ng-template mat-tab-label>
      {{ menuTab | uppercase}}
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #lastHeader>
  <div class="lastHeader" *ngIf="!router.url.includes('/marktplatz')"></div>
</ng-template>
